<template>
    <v-dialog width="500" v-model="showPODialog">
        <v-card>
            <v-card-title class="secondary white--text">
                <span> Update Purchase Order No. </span>

                <v-spacer></v-spacer>
                <v-btn icon @click="showPODialog = false">
                    <v-icon class="white--text">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-2">
                <v-form v-if="showPODialog" v-model="isValid">
                    <v-row class="ma-0">
                        <v-col cols="12" class="Form-Columns">
                            <InputField type="text" label="Purchase Order NO. *" hide-details="auto"
                                :rules="[(val) => !!val || 'Purchase Order NO is required']" v-model="formDetails.po_no"
                                :error-messages="formErrors.po_no" @input="delete formErrors.po" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
                <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">
                    Submit
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";

export default {
    components: {
        InputField,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },

        po: {
            type: [Number, String],
            default: null
        },
        id: {
            type: [Number, String],
            default: null
        }



    },
    computed: {
        showPODialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    data() {
        return {


            isValid: true,
            formErrors: {},
            formDetails: {},
        };
    },
    watch: {
        value(val) {
            if (val) {

                this.formDetails = {
                    po_no: this.po,
                    id: this.id
                };
            } else {
            }
        },
    },
    methods: {



        submitForm() {
            this.$bus.$emit("showLoader", true);
            let payload = {
                po_no: this.formDetails.po_no,
                id: this.formDetails.id

            };

            this.$api.deliveryAdvice
                .updateDAPO(payload)
                .then((res) => {
                    this.showPODialog = false;
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "PO Updated Successfully!",
                        color: "success",
                    });
                    this.formErrors = {};
                    this.$emit("refreshList");
                })
                .catch((err) => {
                    this.formErrors = {};
                    this.$bus.$emit("showLoader", false);
                    this.$bus.$emit("showToastMessage", {
                        message: "Couldn't update po!",
                        color: "error",
                    });
                });
        },
    },
};
</script>
